// extracted by mini-css-extract-plugin
export default {"root":"WhitelistedNFTInput_root__BIxCb","delete":"WhitelistedNFTInput_delete__a4VOH"};